/* The stretch beads can be pulled. 9 September 2026.
   Andre: "so you can move it back and forth but only to the number that it says
   so 350 only gets to pull to 350 vs the 1000%."

   This script only reads the pointer and writes two numbers onto the track,
   --pull and --strain; every pixel comes from the stylesheet. --pull runs from
   0 (rest length, the 1x mark) to 1 (the figure on the datasheet) and is
   clamped there, so no bead can ever be drawn longer than its number. Pulling
   past the cap raises --strain instead, which the stylesheet turns into
   necking. Release sets both back and the stylesheet's transitions do the
   spring. Pointer events, so a finger works the same as a mouse; the track's
   touch-action: pan-y keeps vertical scrolling alive. */
(function () {
  var rows = document.querySelectorAll('.nbn-vs .nbn-vs__row');
  if (!rows.length) return;

  Array.prototype.forEach.call(rows, function (row) {
    var track = row.querySelector('.nbn-vs__track');
    var bar = row.querySelector('.nbn-vs__bar');
    if (!track || !bar) return;
    var n = parseFloat(track.style.getPropertyValue('--n'));
    if (!(n > 1)) return;                      // a 1x bead has nowhere to go

    var dragging = false, x0 = 0, end0 = 0;

    function set(pull, strain) {
      track.style.setProperty('--pull', pull.toFixed(4));
      track.style.setProperty('--strain', strain.toFixed(3));
    }

    bar.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      x0 = e.clientX;
      end0 = bar.getBoundingClientRect().right - track.getBoundingClientRect().left;
      row.classList.add('is-pulling');
      row.classList.remove('is-settling');
      try { bar.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });

    bar.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var tw = track.getBoundingClientRect().width;
      if (!tw) return;
      var endPct = (end0 + (e.clientX - x0)) / tw * 100;   // where the free end would go
      var raw = (endPct / 10 - 1) / (n - 1);               // 0 at rest, 1 at the figure
      var pull = Math.max(0, Math.min(1, raw));
      var strain = raw > 1 ? Math.min(1, (raw - 1) * (n - 1)) : 0;   // past the cap: neck, do not lengthen
      set(pull, strain);
    });

    function release() {
      if (!dragging) return;
      dragging = false;
      row.classList.remove('is-pulling');
      row.classList.add('is-settling');
      set(1, 0);
    }
    bar.addEventListener('pointerup', release);
    bar.addEventListener('pointercancel', release);
    bar.addEventListener('lostpointercapture', release);
    bar.addEventListener('animationend', function () { row.classList.remove('is-settling'); });
  });
}());
